
export class CustomerLoginRequest {
    public userId: string;
    public password: string;
    public otp: string;
}
